import type { FC } from "react";
import type { IconType } from "react-icons";
import { colours } from "../../styles/colours.constants";
import Icon from "../icon/icon";
import * as CSS from "./icon-button.styles";

type IconButtonProps = {
	icon: IconType;
	onClick: () => void;
	disabled?: boolean;
};

const IconButton: FC<IconButtonProps> = ({ icon, onClick, disabled }) => {
	return (
		<CSS.IconButton type="button" onClick={onClick} disabled={disabled}>
			<Icon size={24} icon={icon} color={colours.white} />
		</CSS.IconButton>
	);
};

export default IconButton;
